<template>
    <div>
        <b-modal ref="modal-share-catalog" id="modal-share-catalog" size="md" centered hide-footer
                 v-if="contactData != null">
            <div class="row">
                <div class="col-12 text-center">
                    <h4>Ingresa el correo para enviar este catálogo</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center">
                    <input v-on:keyup.enter="validateData()" v-model="userCredentials.email"
                           @blur="validateFormat('email', 'email')" type="email"
                           class="form-control text-center" placeholder="Correo Electrónico">
                    <label class="validation" v-show="errors['email']">{{ errors['email'] }}</label>
                </div>
                <div class="col-12 col-md-12 text-center">
                    <button :disabled="isLoading" @click="validateData()" class="btn btn-primary mt-4 w-50">
                        Enviar
                        <span v-if="isLoading" class="spinner-border text-light spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                        </span>
                    </button>
                    <br>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        type: String,
        branch_id: String,
        source: String
    },
    data() {
        return {
            userCredentials: {
                email: null,
            },
            isLoading: false,
            errors: {},
            contactData: null,
        }
    },
    mounted() {
        this.getContactSession();
    },
    methods: {
        validateFormat(inputName, format) {
            let regex = null
            switch (format) {
                case 'email':
                    regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    break
                case 'number':
                    regex = /^-?\d+\.?\d*$/
                    break
            }
            delete this.errors[inputName]
            // Restore reactivity on object
            this.errors = Object.assign({}, this.errors)
            if (!this.userCredentials[inputName]) {
                this.errors[inputName] = 'Este campo es requerido'
                this.errors = JSON.parse(JSON.stringify(this.errors))
            } else {
                if (regex && !regex.test(String(this.userCredentials[inputName]).toLowerCase())) {
                    this.errors[inputName] = 'El formato no es valido'
                    this.errors = JSON.parse(JSON.stringify(this.errors))
                }
            }
        },
        validateData() {
            // Verify all inputs
            this.validateFormat('email', 'email')
            if (Object.entries(this.errors).length === 0 && this.errors.constructor === Object) {
                this.sendMail()
            }
        },
        async sendMail() {
            this.isLoading = true
            let location = null
            let formData = new FormData()
            let data = {
                sucursal_id: this.branch_id,
            }
            await this.$axios.post('/settings/get-location-data', data).then(response => {
                location = response.data
            })

            let start = this.$moment(location.store_schedule[0].open_time, 'hh:mm A').format('hh:mm A')
            let end = this.$moment(location.store_schedule[0].close_time, 'hh:mm A').format('hh:mm A')

            start = start !== 'Invalid date' ? start : '09:00 AM'
            end = end !== 'Invalid date' ? end : '09:00 PM'

            data = {
                source: this.source,
                sender: `${this.contactData.data.data.given_name} ${this.contactData.data.data.last_name}`,
                email: this.userCredentials.email,
                type: 'catalog',
                photo: '/public-assets/mail-catalog',
                store_title: location.title,
                address: location.geo_data.address,
                schedule: `${location.store_schedule[0].days} de ${start} a ${end}`,
                url_catalog: `${window.location.origin}/catalogo/${this.branch_id}`,
                url_catalog_pdf: `${window.location.origin}/catalogo-pdf/${this.branch_id}`,
                sender_id: this.contactData.data.data.id,
                branch_id: location.id,
                branch_location_id: location['location-id'],
                product_id: 0,
                sender_mail: this.contactData.data.data.email
            }

            Object.entries(data).forEach(
                ([key, value]) => formData.append(key, value)
            )
            this.$axios.post('/api/send-catalog', formData)
                .then(() => {
                    let alert = this.$alerts['share-full-catalog'].content.values
                    this.$awn.success(alert.description.value.replace('varMail', this.userCredentials.email), {labels: {success: alert.title.value}})
                    this.userCredentials.email = null
                    this.$refs['modal-share-catalog'].hide()
                })
                .catch(error => {
                    console.error(error)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        getImageProduct(product) {
            if (product.hasOwnProperty('articulo_fotos') && product.articulo_fotos[0].articulo_foto_imagen != null) {
                return `/public-assets/${product.articulo_fotos[0].articulo_foto_imagen.slug}`
            } else {
                return '/public-assets/not-picture'
            }
        },
        getBranchProduct(product) {
            let branch = 'No disponible'
            if (product.hasOwnProperty('skus') && product.skus.length > 0) {
                if (product.skus[0].hasOwnProperty('inventories') && product.skus[0].inventories.length > 0) {
                    if (product.skus[0].inventories[0].hasOwnProperty('locations')) {
                        branch = product.skus[0].inventories[0].locations.title
                    }
                }
            }
            return branch
        },
        getPriceList(product) {
            let price = '0'
            if (product.hasOwnProperty('skus')) {
                if (product.skus[0].hasOwnProperty('prices')) {
                    price = this.formatPrice(product.skus[0].prices[0].price)
                }
            }
            return price
        },
        getSalePrice(product) {
            let price = '0'
            if (product.hasOwnProperty('precio_venta')) {
                price = this.formatPrice(product.precio_venta)
            }
            return price;
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        getContactSession() {
            this.$axios.get('/api/contact-data?simpleData=true').then(response => {
                this.contactData = response.status !== 401 ? response : null
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'vue-awesome-notifications/dist/styles/style.css';
</style>
<style>
.modal-header {
    border-bottom: 0 !important;
    padding: 0 !important;
    margin: 10px 15px 0 0;
    background: white;
}
</style>